import {styled} from '@mui/system';
import {Button} from '@mui/material';

export const MuiButtonSectionButton = styled(Button)(({theme}) => ({
	marginRight: theme.spacing(1.5),
	color: theme.palette.background.default,
}));
